import { Aspect } from '@teambit/harmony';

export const WorkspaceConfigFilesAspect = Aspect.create({
  id: 'teambit.workspace/workspace-config-files',
});
